import React from "react";

const TheRAF = () => {
  return (
    <>
      <h1 className="centerBlogTitle">
        The Royal Air Force – my part in its downfall, with apologies to Spike
        Milligan
      </h1>

      <h3>Chapter One</h3>

      <div>
        <img
          src="/images/ericRaf.jpg"
          alt="A young serviceman in RAF uniform."
          loading="lazy"
          className="responsive-image"
          style={{ width: "15rem", height: "20rem" }}
        />
        <p className="textAroundImage">
          One of my earliest childhood memories, (I think it was 1956) was being
          taken to the cinema by my Uncle Eric, who lodged' with my family at
          the time. I was about six years old. The film we went to see was 'The
          Dambusters' which had just reached the local cinema in Tilbury, Essex.
          As we walked home, Uncle Eric told me that his oldest brother, Len,
          had been one of the Dambusters, but was sadly, one of those who did
          not return! I remember telling him, there and then, that when I grew
          up, I would join the RAF to take his place. I learned some years
          later, that Uncle Eric had been a little bit 'poetic' in his story!
          Sergeant Len Gaffee was not a Dambuster, but was a Wireless Operator /
          Air Gunner, flying on Stirling bombers with 149 Squadron, based at RAF
          Mildenhall. He failed to return from an overnight sortie to bomb the
          German city of Mannheim on the night of 5 th /6 th September 1943. But
          the die was cast that day I saw the film because, from that moment on,
          I was obsessed with the desire to take my uncle's place in the RAF.
          <br />
          <br />
          Leaping ahead some forty years, in 2001, I attended a reunion of those
          lucky children with whom I shared my schooling from 1955 to 1961. The
          organiser had found half of the class, some twenty of us, and our
          final form teacher, Mrs Newman, who had taught us for the last two
          years we were at Manorway Junior School in Tilbury. Amazingly, we
          recognised each other, just one of two needed to be identified in the
          class photo from 1961, and then we could see who everyone was. One of
          my former classmates, Dennis, came up to me shook me vigorously by the
          hand and said that he very much admired me! I was surprised and asked
          why I was worthy of such an accolade. He explained that I had bored
          him, and many others, for years with my constant focus on the RAF and
          all military aircraft, and how I was going to be a pilot in the RAF
          when I left school. I said that I did not make it to be a 'proper'
          pilot, but he insisted that I had persisted and had become aircrew in
          the RAF and no one else that he knew, had achieved their childhood
          dream. As an aside, when I approached Mrs Newman, before I could
          speak, she said, "How are you Paul, and how are Jane and Ann? Jane and
          Ann are my two sisters who attended the same school leaving in 1964
          and 1966 respectively! I wish I had a memory as good as that. It would
          really come in handy now!
        </p>
      </div>

      <h3>Chapter Two</h3>

      <div>
        <img
          src="/images/paul.jpeg"
          alt="The author, Paul, in RAF uniform."
          loading="lazy"
          className="responsive-image"
          style={{ width: "20rem", height: "23rem" }}
        />
        <p className="textAroundImage">
          Another early memory, this time I have the date, Saturday 5 th January
          1963. I visited the Boys and Girls Exhibition at Olympia in London.
          Once I saw that there was a stand for the Air Training Corps, I lost
          interest in everything else. I knew at that moment I had to join and
          was so disappointed when advised that the minimum age for entry was
          fourteen years and three months! I had to wait another fifteen months;
          how would I manage? Thankfully, my advisor sensing my obvious
          disappointment, told me that most squadrons would accept
          'probationers' from thirteen and a half years, but until the age of
          fourteen years and three months, a cadet could not be enrolled or
          issued with his uniform. At least now I only had nine months to wait
          to get involved. The nearest ATC Squadron, No 106 (Orsett Hundred)
          Squadron, met on Wednesday evenings from seven till nine and on Sunday
          mornings from ten till twelve, in the Drill Hall in nearby Grays, just
          a short bus ride from my home. So, at ten o'clock on the morning of
          Sunday 14 th September, I was there to join up.
          <br />
          <br />
          The first session was an introduction to drill – and it felt as
          natural to me as walking, unlike some of the other first timers! After
          a refreshment break, we had a lesson on the theory of flight, and I
          was totally hooked! I think that between that date and my final visit
          to the squadron headquarters (necessitated by me joining the RAF!) I
          only missed a handful of meetings.
          <br />
          <br />
          The six months flew by and soon I was proudly wearing the uniform,
          although I did have trouble finding collar studs! Plus, the 'hairy
          blue' trousers did play havoc with my upper thighs until the 'fluff'
          wore off! I was also introduced art of 'bulling' one's boots – of the
          hobnailed variety. They arrived with the 'bubbly' finish that took
          many hours to wear down using a bone first and then a large tablespoon
          – my mum never did find out what had happened to that spoon! Soon I
          achieved the desired 'mirror finish' and the experience gained was to
          prove very useful when I did join the RAF.
        </p>

        <p style={{ marginTop: "3rem" }}>
          I completed all the stages of advancement, achieving the top marks in
          my progress from First Class Cadet, through Leading Cadet and Senior
          Cadet to Staff Cadet. I was also promoted to corporal, sergeant,
          flight sergeant and eventually to Cadet Warrant Officer. Summer camps
          were an absolute delight, getting to see the RAF 'up close and
          personal.' I was fortunate to be selected to attend one summer camp at
          RAF Bruggen, in Germany. It was at RAF Binbrook in Lincolnshire in
          1965 that I got airborne for the first time, in a Chipmunk aircraft
          flown by a Lightning pilot, helping for the day! I struggled at first
          to understand the very clipped formal communication between the pilot
          and the Air Traffic Control. However, I clearly understood the pilot
          when he applied power to the engine to get us moving towards the
          runway when he yelled, "God this f**king aircraft is falling apart!" I
          was amazed to be airborne, and the thirty-minute trip included a few
          basic aerobatics before the pilot let me have control and I tried to
          fly straight and level, before trying a few turns without losing or
          gaining height! I also got to fly these trips in a Chipmunk at summer
          camps and on the occasional trips to RAF North Weald or Marshall
          Airport, near Cambridge. My favourite pilot at this airport was a
          retired very senior officer (rumoured to have been an Air Marshal!)
          now serving as a flying officer, who loved to undertake 'strafing'
          runs attacking the traffic on the nearby A14.
        </p>

        <p>
          Once sixteen years old, cadets were invited to apply a place on the
          basic gliding course, based at RAF Swanton Morely, in the wilds of
          Norfolk. I delayed my application to try to try and get the academic
          qualifications I needed for aircrew service in the RAF. My standard
          school report comment was always 'bright but lazy, must work harder'!
          But despite that accolade, I did manage to get six GCE 'O' Levels,
          including English, Maths and Physics with Chemistry – the important
          ones, plus French, history, and geography.
        </p>

        <p>
          It was about this time that I made my first formal application to the
          RAF. I applied for a Flying Scholarship, a scheme which offered the
          forty hours flying needed to acquire a Private Pilot's Licence (PPL)
          at a civilian flying club. The selection process was conducted at the
          Officer and Aircrew Selection Centre (OASC), RAF Biggin Hill and was
          very much the same as the process for a full-blown application to join
          the RAF as a pilot.
        </p>

        <p>
          I had not been able to find out much about what the visit entailed, so
          went along full of enthusiasm and confidence. The three days covered a
          series of different, but very thorough medical examinations, a
          forty-minute interview conducted by two senior officers, a series of
          aptitude tests, discussion and problem-solving exercises in groups of
          five or six candidates and finally, practical leadership exercises in
          the same groups, conducted over obstacle courses in a hangar, that
          reminded me of the game show, 'It's a knockout'!
        </p>

        <p>
          After a short debrief, during which I was told that I had passed the
          medical and would expect to hear the full results in a few weeks. In
          due course, the brown envelope arrived and to my consternation, I
          discovered that I had not been successful in my application. I do not
          think that I read beyond that point, not bothering to see why I had
          failed. Having convinced myself that there had been an error, I
          continued with my plans by attending the basic gliding course that was
          offered to me.
        </p>
      </div>

      <h3>Chapter Three</h3>
      <p>
        It was an interesting journey to RAF Swanton Morely, located in the
        middle of nowhere, or so it seemed – it was actually in Norfolk, but
        still a long way from civilisation as it knew it!. The bonus was that
        the tallest of our number had no problem getting served in the local
        pub, the Angel, and some of us even made the longer walk to the
        Papermakers Arms! We were so far away from any form of civilisation, I
        suspect that the landlords were just glad of the custom and just assumed
        that we were airmen from RAF Swanton Morely. The gliding though was
        unbelievable! The course entitled us to twenty-five launches of which up
        to three could be solo if we impressed our instructors enough. Achieving
        the three solos meant that we could attach the 'gliding wings' to our
        uniforms! Each launch typically got us up to around one thousand to
        twelve hundred feet above the airfield, which enabled us to achieve a
        flight of between two to four minutes. It was during these short periods
        of time that we were taught everything we had to know and do, to be
        allowed to achieve our three solo flights. All my flights were in the
        Kirby Cadet Mk3 glider with tandem seating, me in the front and my
        instructor behind. I often reflect on the decision made by my instructor
        to let me fly solo after just nineteen launches. I can still remember
        that launch, running through the mnemonic to the pre-flight checks –
        CISTRS – controls, instruments, spoilers, trim, release, straps! I then
        called "All clear above and behind" and that was it, the signal was
        passed to the winch operator, and I as off! Reaching the point where the
        cable began to pull me down rather than lift me up, I gently lowered the
        nose of the glider and pulled the cable release. And then – Silence! I
        was amazed at the quiet after the usual noise heard while being launched
        into the air by the winch. I was suddenly overcome by the urge to sing –
        something for which I am totally unsuited! Before I knew what had
        happened, I was safely on the ground and feeling desperate to go again.
        I was pulled back into the launch position by my fellow students and the
        cable was reattached. A quick debrief by my instructor, who had
        monitored my progress with the aid of a pair of powerful binoculars, and
        I was airborne once again. Far too soon, I had completed my third solo
        landing, and I asked if I could use up my other three remaining launches
        with more solo flights. Alas, the rules precluded that option, but my
        final three launches were spent doing aerobatics, play time for my
        instructor but very enjoyable.
      </p>

      <p>
        On our last morning, my instructor approached me and asked if I had had
        any difficulty in getting time off school for the gliding course. I
        replied that as it was an activity very much linked to my chosen career
        path, there had been no issues. He asked if I would be able to get two
        more weeks off school, one in February 1967, to return to RAF Swanton
        Morely for a refresher and to convert to flying the single set
        sailplane, which I think was the Slingsby Swallow. Then later in the
        late spring/early summer, the second week would entail being based at
        RAF Locking in Somerset, to learn the art of 'ridge soaring' with the
        chance to fly for much longer periods of time! I felt as though I had
        won the biggest jackpot ever! Assuring my instructor that I could
        guarantee that I would be available, I departed with a greater sense of
        certainty that I would achieve my ambition to be a pilot in the Royal
        Air Force.
      </p>
    </>
  );
};

export default TheRAF;
